import { useEffect, useState } from "react";
import { Container, Navbar } from "react-bootstrap";
import { EnhancedButton } from "../buttons/EnhancedButton";

export default function CookieAlert() {
	const [accepted, setAccepted] = useState<boolean | null>(null);

	useEffect(() => {
		const stored = localStorage.getItem("cookieConsent");
		if (stored === "true") {
			setAccepted(true);
		} else {
			setAccepted(false);
		}
	}, []);

	const handleAccept = () => {
		localStorage.setItem("cookieConsent", "true");
		setAccepted(true);
	};

	if (accepted) return null;
	return (
		<Navbar bg="primary" fixed="bottom">
			<Container>
				<span>We use essential cookies to keep you logged in and secure. By continuing to use this site, you agree to these cookies.</span> <EnhancedButton onClick={handleAccept}>OK</EnhancedButton>
			</Container>
		</Navbar>
	);
}
